import { styled, typography } from '@pulse-web-ui/theme';

export const SubWidgetHeader = styled.h3`
  ${typography.medium20};
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const PersonalDataAgreementHint = styled.p`
  ${typography.regular14}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  max-width: 400px;
  line-height: 20px;
`;
